'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-errors/eval.js
 ** module id = 626
 ** module chunks = 73
 **/